import ILandingDomain from "@/interfaces/ILandingDomain";
import IMultiSelectItem from "@/interfaces/selects/IMultiSelectItem";
import cloneObject from "@/libs/cloneObject";
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';

import Loader from '@/components/Includes/Loader/Loader.vue';
import LandingDomainForm from '@/components/LandingDomains/LandingDomainForm/LandingDomainForm.vue';
import {Action} from "vuex-class";

@Component({
    name: 'LandingDomainCreate',
    components: {
        Loader,
        LandingDomainForm
    }
})

export default class LandingDomainCreate extends Vue {
    @Prop(String) private modalId!: string;
    @Prop(String) private modalTitle!: string;
    @Prop({type: Boolean, default: false}) private hideFooter!: boolean;
    @Prop(Boolean) private showModal!: boolean;
    @Prop(Array) private landingRegions!: IMultiSelectItem[];

    // Begin Vuex Logic for Landing Domain
    @Action private landingDomainCreate!: (form: ILandingDomain) => string;
    // End Vuex Logic for Landing Domain

    private loading: boolean = true;

    private show: boolean | null = null;

    private initLandingDomainData: ILandingDomain = {
        url: '',
        region: ''
    };

    @Watch('showModal')
    private toggleModal(): void {
        this.show = this.showModal;
    }

    private closeModal() {
        this.initLandingDomainData.url = '';
        this.initLandingDomainData.region = '';
        this.$emit('closeModalLandingDomain')
    }

    private checkValidValues(){
        (this.$refs.landingDomainForm as HTMLFormElement).handleSave()
    }

    private async createLandingDomain() {
        const prefix: string = '/api/cloudflare/landing_regions';

        const form = cloneObject(this.initLandingDomainData);

        form.region = `${prefix}/${form.region.value}`;

        try {
            this.loading = true;

            const changeStatus = await this.landingDomainCreate(form);

            if (changeStatus === 'created') {
                this.loading = false;

                this.closeModal();

                this.$emit('UpdateLandingDomains');

                this.$notify({
                    group: 'notice',
                    title: `Domain ${form.url}`,
                    text: 'Created Successfully',
                    type: 'success'
                });
            } else {
                this.loading = false;
            }
        } catch (error) {
            throw new Error(error)
        }
    }

    private mounted (){
        this.loading = false;
    }
}